import React from 'react'

import { toast } from 'react-toastify'

import { digObject } from '@domain-group/javascript-utils'

import api from '@functions/api'

const openUrl = (href: string, afterAction?: () => void, beforeAction?: () => void, toastMessage?: string) => {
  const config = {
    responseType: 'blob',
    // @ts-expect-error TS7006
    transformResponse: r => r,
  }

  if (beforeAction) beforeAction()

  if (toastMessage) toast.success(toastMessage)

  // @ts-expect-error TS2345
  return api(href, {}, config)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', response.headers.filename)

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      if (afterAction) afterAction()
    })
    .catch((error) => {
      // @ts-expect-error TS7006
      error?.response?.data?.text().then((responseObject) => {
        const { errors = ['Something went wrong'] } = JSON.parse(responseObject) || {}
        toast.warn(errors[0])
      })

      if (afterAction) afterAction()
    })
}

interface AuthenticatedDownloadProps {
  callbacks?: {
    afterAction: () => void,
    beforeAction?: () => void,
  },
  children: React.ReactNode,
  toastMessage?: string,
}

const AuthenticatedDownload = (props: AuthenticatedDownloadProps) => {
  const { callbacks, children, toastMessage } = props
  const { afterAction, beforeAction } = callbacks || {}
  // @ts-expect-error TS2345
  const href = digObject(children, 'props.href')

  // @ts-expect-error TS2769
  return React.cloneElement(children, {
    href: null,
    onClick: () => openUrl(href, afterAction, beforeAction, toastMessage),
  })
}

export default AuthenticatedDownload
